var useSchoolConfig = function useSchoolConfig() {
  var user = JSON.parse(sessionStorage.getItem('user'));
  var learningObjectiveLabel = (user === null || user === void 0 ? void 0 : user.learning_objective_label) || 'Learning Objectives';
  var msTeamsPermissionMissing = !!(user !== null && user !== void 0 && user.ms_teams_permission_missing);
  var trialEnds = user === null || user === void 0 ? void 0 : user.trial_ends;
  var nurtureAIEnabled = user === null || user === void 0 ? void 0 : user.nurture_ai_enabled;
  var curriculumBoundaryEnabled = (user === null || user === void 0 ? void 0 : user.curriculum_boundary_enabled) && false; // disabled on stand alone
  var rubricsEnabled = user === null || user === void 0 ? void 0 : user.rubrics_enabled;
  var channelOnboarding = user === null || user === void 0 ? void 0 : user.channel_onboarding;
  var trialEnded = !!trialEnds && new Date() > new Date(trialEnds);
  return {
    user: user,
    learningObjectiveLabel: learningObjectiveLabel,
    msTeamsPermissionMissing: msTeamsPermissionMissing,
    trialEnds: trialEnds,
    nurtureAIEnabled: nurtureAIEnabled,
    curriculumBoundaryEnabled: curriculumBoundaryEnabled,
    rubricsEnabled: rubricsEnabled,
    trialEnded: trialEnded,
    channelOnboarding: channelOnboarding
  };
};
export default useSchoolConfig;